<template>
  <div class="h-full w-full flex flex-col">
    <template v-if="ready">
      <client-only>
        <app-banner />

        <div
          v-if="active && accounts"
          class="box-border text-base font-normal flex relative h-full overflow-hidden"
          :class="[
            dev ? 'bg-teal-900' : 'bg-secondary'
          ]"
        >
          <!-- Temp grants display -->

          <div v-if="grants" class="hidden fixed top-0 right-0 m-2 px-3 py-2 rounded-lg text-sm bg-gray-700 shadow text-white z-80000 group cursor-pointer">
            Grants required

            <div class="hidden group-hover:block p-3 bg-white border absolute text-gray-800 shadow rounded-lg top-0 left-1/2 translate-y-full -translate-x-1/2 w-52">
              <ul>
                <li v-for="(actions, grant) in grants" :key="grant">
                  <span class="capitalize font-semibold">{{ grant }}</span> - {{ actions.join(', ') }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Sidebar -->
          <nav-menu />

          <!-- Right -->
          <div class="flex max-w-full flex-col flex-grow transition-all duration-500 ease-in-out overflow-hidden relative">
            <!-- Content -->
            <div class="flex-grow h-100 flex-shrink bg-gray-200 sm:rounded-l-lg overflow-hidden shadow-lg">
              <nuxt />
            </div>

            <mobile />
          </div>

          <search />

          <lock />

          <panel-controller />

          <portal-target name="modal-container" multiple />
          <portal-target name="dialog-container" multiple />
        </div>
      </client-only>
    </template>

    <loading />

    <transition name="fade">
      <div v-if="mobile" class="sm:hidden fixed inset-0 h-full w-full bg-black bg-opacity-15" @click="setMobile(false)" />
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'

import NavMenu from '@/components/layout/Menu'

import Search from '@/components/search/Search'
import Loading from '@/components/layout/Loading'
import Mobile from '@/components/layout/Mobile'
import AppBanner from '@/components/layout/AppBanner'

import Lock from '@/components/auth/elements/Lock'

import PanelController from '@/components/panel/PanelController'

import {
  OInternalLink
} from '@/components/elements'

export default {
  components: {
    NavMenu,
    Search,
    Loading,
    Mobile,
    AppBanner,
    Lock,
    PanelController,
    OInternalLink
  },
  head () {
    return {
      title: this.$auth.info ? this.$auth.info.location.title + ' - Ovatu Manager' : 'Ovatu Manager'
    }
  },
  computed: {
    ...mapGetters({
      active: 'auth/active',
      accounts: 'auth/accounts',
      ready: 'auth/ready',
      mobile: 'mobile'
    }),
    grants () {
      const route = this.$route
      const grants = route.meta?.grants

      return grants
    },
    dev () {
      return this.$config.instance === 'dev'
    }
  },
  mounted () {
    this.setWidth(window.innerWidth)

    window.addEventListener('resize', () => {
      this.setWidth(window.innerWidth)
    })

    this.notifications()
  },
  methods:{
    ...mapMutations([
      'setWidth',
      'setMobile'
    ]),
    async notifications () {
      const notifications = this.$auth.info?.panels || []

      for (const notification of notifications) {
        const options = {
          title: notification.title,
          text: notification.content,
          variant: notification.type,
          duration: 10000,
          width: 'w-200'
        }

        if (notification.action) {
          if (notification.action.internalUrl) {
            options.action = {
              click: () => {
                const url = this.$redirect?.match(notification.action.internalUrl)
                this.$router.push(url)
              },
              label: notification.action.title
            }
          } else if (notification.action.url) {
            options.action = {
              click: () => { window.location = notification.action.url },
              label: notification.action.title
            }
          }
        }

        this.$notification.toast(options)
      }
    }
  }
}
</script>
